<button
  *ngIf="hasMoreAfter"
  class="chat-session-list__load-more"
  type="button"
  [disabled]="isLoadingAfter"
  (click)="onLoadMoreAfter()"
>
  <span class="chat-session-list__load-more-body">Загрузить предыдущие</span>
</button>
<chat-session-item
  *ngFor="let s of sessions"
  [session]="s"
  [type]="type"
  [showAvatar]="showAvatar"
  [showOnlineIndicator]="showOnlineIndicator"
  [showUnreadCount]="showUnreadIndicator"
  [menuItems]="menuItems ? menuItems(s) : []"
  (deleted)="sessionDeleted.emit(s.id)"
  (selected)="sessionSelected.emit(s.id)"
></chat-session-item>
<button
  *ngIf="hasMoreBefore"
  class="chat-session-list__load-more"
  type="button"
  [disabled]="isLoadingBefore"
  (click)="onLoadMoreBefore()"
>
  <span class="chat-session-list__load-more-body">Загрузить ещё</span>
</button>
